const padding = {
  small: '4px 12px',
  medium: '6px 12px',
  large: '8px 12px',
};

export default padding;
